// extracted by mini-css-extract-plugin
export var defaultWrapper = "_if-3";
export var downloadButton = "_if-4";
export var fileContainer = "_if-9 _if-7";
export var fileContainerBase = "_if-7";
export var fileContainerBaseSm = "_if-a _if-7";
export var fileContainerFixedHeight = "_if-8 _if-7";
export var fileContainerFixedHeightSm = "_if-c _if-a _if-7";
export var fileContainerSm = "_if-b _if-a _if-7";
export var fileInfo = "_if-5";
export var fileInfoWidthRestricted = "_if-6";
export var fileType = "_if-1";
export var fileTypeName = "_if-2";
export var fileTypeSm = "_if-d _if-1";
export var image = "_if-0";
export var link = "_if-f";
export var overflowEllipsis = "_if-e";